module.exports = __webpack_public_path__ + "static/mob_logo-985211b28c86fed11d6f0180dc683a67.png";